import Layout from '../../internal/Layout.vue'
import ChronogramPage from './chronogram.vue'

const ChronogramRoutes = {
  component: Layout,
  children: [
    {
      name: 'Chronogram',
      path: '/',
      component: ChronogramPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ChronogramRoutes
